import React from 'react';
import Select from 'react-select';
import Search from 'src/components/Search/Search';
import { ContactRole } from '../helpers/contactShape';
import './ContactSearchAndFilters.scss';

interface ContactSearchAndFiltersProps {
  searchTerm: string;
  selectedRoles: ContactRole[];
  selectedCategories: string[];
  availableCategories: string[];
  availableRoles: ContactRole[];
  onChangeSearchTerm: (term: string) => void;
  onChangeSelectedRoles: (roles: ContactRole[]) => void;
  onChangeSelectedCategories: (categories: string[]) => void;
}

interface RoleOption {
  value: ContactRole;
  label: ContactRole;
}

interface CategoryOption {
  value: string;
  label: string;
}

const MENU_PORTAL_STYLES = {
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
};

const ContactSearchAndFilters = ({
  searchTerm,
  selectedRoles,
  selectedCategories,
  availableCategories,
  availableRoles,
  onChangeSearchTerm,
  onChangeSelectedRoles,
  onChangeSelectedCategories,
}: ContactSearchAndFiltersProps) => {
  const roleOptions: RoleOption[] = availableRoles
    .filter((role: ContactRole) => role !== 'Unrecognized')
    .map((role: ContactRole) => ({
      value: role,
      label: role,
    }));

  const selectedRoleOptions: RoleOption[] = roleOptions.filter(
    (option: RoleOption) => selectedRoles.includes(option.value)
  );

  const categoryOptions: CategoryOption[] = availableCategories.map(
    (category: string) => ({
      value: category,
      label: category,
    })
  );

  const selectedCategoryOptions: CategoryOption[] = categoryOptions.filter(
    (option: CategoryOption) => selectedCategories.includes(option.value)
  );

  return (
    <div className="contact-search-and-filters">
      <div className="cpf-row">
        <div className="cpf-filter cpf-filter-search">
          <Search
            size={undefined}
            theme={undefined}
            placeholder="Search by name, company, or service"
            value={searchTerm}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChangeSearchTerm(e.target.value)
            }
          />
        </div>
      </div>

      <div className="cpf-row">
        <div className="cpf-filter cpf-filter-select">
          <Select
            isMulti
            options={roleOptions}
            value={selectedRoleOptions}
            placeholder="Role"
            isSearchable={false}
            classNamePrefix="spc-react-select"
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={MENU_PORTAL_STYLES}
            onChange={(options: any) => {
              const next: RoleOption[] = options || [];
              onChangeSelectedRoles(next.map((o: RoleOption) => o.value));
            }}
          />
        </div>

        <div className="cpf-filter cpf-filter-select">
          <Select
            isMulti
            options={categoryOptions}
            value={selectedCategoryOptions}
            placeholder="Service"
            isSearchable
            classNamePrefix="spc-react-select"
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={MENU_PORTAL_STYLES}
            onChange={(options: any) => {
              const next: CategoryOption[] = options || [];
              onChangeSelectedCategories(next.map((o: CategoryOption) => o.value));
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactSearchAndFilters;
